import { z } from 'zod';
export const syncModeSchema = z.enum(['FULL', 'INCREMENTAL']);
export const beginSyncRunRequestSchema = z
    .object({
    mode: syncModeSchema,
    snapshotId: z.uuid(),
})
    .strict();
export const syncItemSchema = z
    .object({
    externalId: z.string().trim().min(1).max(191),
    sourceType: z.enum(['WP_PAGE', 'WP_POST', 'WP_PDF']),
    revision: z.number().int().positive().max(2_000_000_000),
    action: z.enum(['UPSERT', 'DELETE']),
    title: z.string().trim().max(500).optional(),
    url: z.string().trim().max(2000).optional(),
    locale: z.string().trim().max(16).nullable().optional(),
    contentText: z.string().max(100_000).optional(),
    contentHash: z
        .string()
        .regex(/^[a-f0-9]{64}$/)
        .optional(),
})
    .strict();
export const syncItemsRequestSchema = z
    .object({
    items: z.array(syncItemSchema).min(1).max(20),
})
    .strict();
export const completeSyncRunRequestSchema = z
    .object({
    status: z.enum(['SUCCEEDED', 'FAILED']),
    errorCode: z.string().trim().max(64).optional(),
})
    .strict();
export const pdfSyncActionSchema = z.enum(['UPSERT', 'DELETE']);
export const pdfSyncHeadersSchema = z
    .object({
    externalId: z.string().trim().regex(/^attachment:\d+$/).max(191),
    revision: z.coerce.number().int().positive().max(2_000_000_000),
    fileHash: z.string().regex(/^[a-f0-9]{64}$/),
    title: z.string().trim().max(500),
    url: z.string().trim().url().max(2000).optional(),
    locale: z.string().trim().max(16).nullable().optional(),
    action: pdfSyncActionSchema,
})
    .strict();
export const pdfSyncResponseSchema = z
    .object({
    externalId: z.string(),
    action: pdfSyncActionSchema,
    status: z.enum(['accepted', 'duplicate', 'deleted']),
    sourceId: z.uuid().nullable(),
    versionId: z.uuid().nullable(),
    errorCode: z.string().optional(),
})
    .strict();
//# sourceMappingURL=sync.js.map